import { useState } from "react"
import { useApp } from "../../../hooks/useApp"
import { Button } from "../../ui/Button/Button"
import { Text } from "../../ui/Text/Text"
import { getMainProductVariantById, getPendantProductVariantById } from "./utils"
import { formatCentsToDollars } from "../../../utils/formatCentsToDollars"

interface Props {
  className?: string
}

export const ActiveProductVariantDescription = ({ className }: Props) => {
  const { 
    mainProduct, 
    activeScreen,
    activeMainProductVariantId, 
    active, 
    activePendantProductVaraintIds,
  } = useApp()

  const [moreOpen, setMoreOpen] = useState(false)

  const activeProductVariant = activeScreen === "CHAIN" 
  ? getMainProductVariantById(mainProduct, activeMainProductVariantId)
  : getPendantProductVariantById(mainProduct, activePendantProductVaraintIds[active])
  
  const imageUrls = activeProductVariant.metafields.gallery
  
  const title = activeProductVariant.metafields.title
  const subtitle = activeProductVariant.metafields.subtitle
  const descriptionHtml = activeProductVariant.metafields.description
  
  const handleClick = () => setMoreOpen(!moreOpen)

  return (
    <div className={className}>
      <p className="flex justify-between gap-4">
        <Text>{title}</Text>
        <Text style="heading">{formatCentsToDollars(activeProductVariant.price)}</Text>
      </p>

      <div className="flex justify-end gap-4 mt-2">
        {subtitle && <p><Text className="italic text-subdued">{subtitle}</Text></p>}
        <Button className="shrink-0 ml-auto" onClick={handleClick}>
          <Text style="button-quaternary-dark">{moreOpen ? "Less" : "More"} Details</Text>
        </Button>
      </div>

      {moreOpen && (
        <>
          <div className="overflow-x-auto">
            <ul className="flex items-center gap-3 mt-4">
              {imageUrls.map((url, index) => (
                <li key={index} className="shrink-0 rounded-sm overflow-hidden">
                  <img 
                    className="w-[115px] h-[150px] object-cover"
                    src={url}
                    width="115"
                    height="150"
                    alt={`Photo of ${title}`}
                  />
                </li>
              ))}
            </ul>
          </div>

          <div className="Rte mt-4" dangerouslySetInnerHTML={{ __html: descriptionHtml }}></div>
        </>
      )}
    </div>
  )
}